import React from 'react';
import Header from './Header';
import '../css/App2.css';
//import profile from './profile.jpg';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import img1 from '../images/img1.png';
import img2 from '../images/12.png';
import { Fade,Stagger } from 'react-animation-components';
import img3 from '../images/img3.png';
import Footer from './Footer';
<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto"></link>


function ImgMediaCard(props) {
  return (
    <Fade in>
      <Card sx={{ maxWidth: 345 }}>
        <CardMedia
          component="img"
          alt={props.title}
          height="240"
          image={props.img}
        />
        <CardContent>
          <Typography gutterBottom variant="h5" sx={{ minHeight: 80 }} component="div">
            {props.title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {props.degree} - {props.marks}
          </Typography>
        </CardContent>
        <CardActions>
          <Button size="small">Share</Button>
          <Button size="small">Learn More</Button>
        </CardActions>
      </Card>
    </Fade>
  );
}






// function CardPage(props){
//     return(
//         <div className="cards align-self-center">
//             <Card style={{ width: '18rem' }}>
//             <div className="responsive">
//                 <Card.Img height="100%" width="100%" variant="top" src={props.img}/>
//             </div>
//             <Card.Body>
//                 <Card.Title>{props.title}</Card.Title>
//                 <Card.Subtitle className="mb-2 text-muted">{props.marks}</Card.Subtitle>
//                 <Card.Subtitle className="mb-2 text-muted">{props.degree}</Card.Subtitle>
//                 <div className="btn">
//                     <Button variant="primary">More</Button>
//                 </div>
//             </Card.Body>
//             </Card>
//         </div>
//     );
// }

function Education() {
  return (
    <>
    <Header/>
    <div>
      <Fade in>
      <div className="heading">
        Education
      </div>
      </Fade>

      {/* <div class="coding">
      <h1>Coding Profiles</h1>
      </div> */}

        <div className="container education">
          <Stagger in>
            <div className="row">
                <ImgMediaCard title={"Vishwakarma Institute of Technology"} marks={9.49} degree={"B.Tech Computer Science"} img={img1} />
                <ImgMediaCard title={"M.S Gosavi College"} marks={88.6} degree={"HSC"} img={img2} />
                <ImgMediaCard title={"New Era English School"} marks={89.4} degree={"SSC"} img={img3}/>
            </div>
            </Stagger>
        </div>
    </div>

    
    <Footer/>
    </>
  );
}

export default Education